/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ModuleStatBase
 * auto generated base class for the model ModuleStatModel.
 */
export const ModuleStatModelBase = ModelBase.named('ModuleStat')
  .props({
    __typename: types.optional(types.literal('ModuleStat'), 'ModuleStat'),
    accuracy: types.union(types.undefined, types.number),
    completedTimes: types.union(types.undefined, types.number),
    moduleCompletedTime: types.union(types.undefined, types.null, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ModuleStatModelSelector extends QueryBuilder {
  get accuracy() {
    return this.__attr('accuracy')
  }
  get completedTimes() {
    return this.__attr('completedTimes')
  }
  get moduleCompletedTime() {
    return this.__attr('moduleCompletedTime')
  }
}
export function selectFromModuleStat() {
  return new ModuleStatModelSelector()
}

export const moduleStatModelPrimitives = selectFromModuleStat().accuracy.completedTimes.moduleCompletedTime
